/**
 * Utility functions for date formatting with proper timezone handling
 */

const BRAZIL_TIMEZONE = 'America/Sao_Paulo';

/**
 * Formats a date to Brazilian locale date string (DD/MM/YYYY)
 * with proper timezone handling to avoid off-by-one-day issues
 */
export function formatDateBR(date: string | Date): string {
  return new Date(date).toLocaleDateString('pt-BR', {
    timeZone: BRAZIL_TIMEZONE
  });
}

/**
 * Formats a date to Brazilian locale date and time string (DD/MM/YYYY HH:MM:SS)
 * with proper timezone handling
 */
export function formatDateTimeBR(date: string | Date): string {
  return new Date(date).toLocaleString('pt-BR', {
    timeZone: BRAZIL_TIMEZONE
  });
}
